// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button-navigation[data-v-49632741]{position:fixed;bottom:0;left:0;width:100%;background-color:#fff;text-align:center;padding:1.5em}@media (min-width:768px){.button-navigation[data-v-49632741]{position:relative;padding:0}}.u-button[data-v-49632741]{width:100%}.u-button[data-v-49632741]:last-of-type{margin-top:.75em}@media (min-width:768px){.u-button[data-v-49632741]{width:auto;margin-top:0}.u-button[data-v-49632741]:last-of-type{margin-left:.5em}}", ""]);
// Exports
module.exports = exports;
